export const properties = {
  BEFFE_URL: process.env.BEFFE_URL || '',
  studioUrl: window.location.origin,
  SCANDIT_LICENSE_KEY: process.env.SCANDIT_LICENSE_KEY || '',
  LD_CLIENT_ID: process.env.LD_CLIENT_ID || ''
};

export default properties;
